import { useGetCurrencies } from "api/queries/common/useGetCurrencies";
import Alert from "components/v2/Alert/Alert";
import DatePicker from "components/v2/DatePicker/DatePicker";
import Input from "components/v2/Input/Input";
import InputDropdownGroup from "components/v2/InputDropdownGroup/InputDropdownGroup";
import Radio from "components/v2/Radio/Radio";
import { useIntl } from "react-intl";
import { Controller, useFormContext } from "react-hook-form";

function CreateParcelAccountInvoiceVerification() {
  const { control, watch, setValue } = useFormContext();
  const mfaOption = watch("mfa_option");
  const intl = useIntl();

  const { data: currenciesData }: any = useGetCurrencies({
    select: (data) =>
      data.map((currency) => ({
        value: currency.code,
        label: `${currency.name} (${currency.code})`,
      })) as any,
  });

  return (
    <div className="mt-2xl create-parcel-account__configuration-radio">
      <Controller
        name="mfa_option"
        control={control}
        render={({ field }) => (
          <Radio
            options={[
              {
                label: intl.formatMessage({
                  id: "settings.parcelAccounts.createAccount.mfa.invoiceLabel",
                  defaultMessage: "Invoice",
                }),
                value: "INVOICE",
              },
            ]}
            value={field.value}
            size="md"
            onChange={field.onChange}
          />
        )}
      />
      <div className="create-parcel-account__verification-content">
        <div className="text-md text-tertiary">
          {intl.formatMessage({
            id: "settings.parcelAccounts.createAccount.mfa.invoiceDescription",
            defaultMessage: "Use an invoice that is not more than 90 days old to authenticate your identity",
          })}
        </div>
        {mfaOption === "INVOICE" && (
          <>
            <div className="my-lg mr-5xl">
              <Alert label="" variant="brand">
                <ul className="create-parcel-account__invoice-validation-list">
                  <li>
                    {intl.formatMessage({
                      id: "settings.parcelAccounts.createAccount.mfa.invoiceRequirement1",
                      defaultMessage: "The invoice used should not be more than 90 days old",
                    })}
                  </li>
                  <li>
                    {intl.formatMessage({
                      id: "settings.parcelAccounts.createAccount.mfa.invoiceRequirement2",
                      defaultMessage:
                        "Invoice validation will fail, if you provide any incorrect information on the date, invoice number, amount & currency",
                    })}
                  </li>
                  <li>
                    {intl.formatMessage({
                      id: "settings.parcelAccounts.createAccount.mfa.invoiceRequirement3",
                      defaultMessage:
                        "Your account will be locked for 24 hours after multiple failed attempts. You can choose another verification methods above or contact FedEx tech support",
                    })}
                  </li>
                </ul>
              </Alert>
            </div>
            <div className="mt-lg create-parcel-account__verification-content-input-container">
              <Input
                label={intl.formatMessage({
                  id: "settings.parcelAccounts.createAccount.mfa.invoiceNumberLabel",
                  defaultMessage: "Invoice number",
                })}
                name="invoice_number"
              />
            </div>
            <div className="mt-lg create-parcel-account__verification-content-input-container dropdown-full-width">
              <InputDropdownGroup
                label={intl.formatMessage({
                  id: "settings.parcelAccounts.createAccount.mfa.invoiceAmountLabel",
                  defaultMessage: "Invoice amount",
                })}
                inputPlaceholders={["1,000.00"]}
                names={["invoice_amount"]}
                dropdownName="invoice_currency"
                options={currenciesData || []}
                onDropdownSelect={(val) => setValue("invoice_currency", val)}
                useInputDropdown
                alignRight
              />
            </div>
            <div className="mt-lg create-parcel-account__verification-content-input-container">
              <div className="text-sm font-medium text-secondary-v2 mb-sm">
                {intl.formatMessage({
                  id: "settings.parcelAccounts.createAccount.mfa.invoiceDateLabel",
                  defaultMessage: "Invoice date",
                })}
              </div>
              <DatePicker alignment="right" name="invoice_date" numberOfMonths={1} selectionMode="single" />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
export default CreateParcelAccountInvoiceVerification;
